module.exports = __webpack_public_path__ + "static/media/Icon_Concrete.ef981e07.png";